import styled from 'styled-components';

export const CartFillerMiniCartStyled = styled.div`
  display: flex;
  ${(props) => (props.isPromotionCart ? 'flex: 0 0 33.33%;' : '')}
  ${(props) =>
    props.isPromotionCart &&
    ` margin-right: -6px;
      @media (max-width: 500px){
        padding-left:30px;
        flex:1;
      }
      padding-left: 16px;
      padding-top: 16px;
     
    `}

  .cart-filler-mini-cart {
    display: flex;
    flex-direction: column;
    align-items: ${(props) => (!props.showFillerTitle ? 'flex-start' : 'center')};
    position: relative;
    padding-top: ${(props) => (props.title ? '22px' : '0px')};
    ${(props) =>
      props.isPromotionCart &&
      ` 
        border: 1px solid #E3E9EF ;
        border-radius: 8px;
        padding: 8px;
        height: ${!props.showFillerTitle ? '210px' : 'auto'};
        width: 132px;
        
      `}
  }
  
  .btn.btn-sm {
    padding: 10px 16px; 
  }
  .image-wrapper {
    position: relative;

    .mini-cart-image {
      margin-right: 10px; 
      border: 1.06px solid ${(props) => props.theme.color.borderLight};
      border-radius: 8.5px;
      overflow: hidden;
    }
    .mini-cart-image-promotion{
      margin-right: 10px; 
      border: none;
      border-radius: 8.5px;
      overflow: hidden;
    }
    .product-badge {
      position: absolute;
      padding-top: 2px;
      margin-left: ${(props) => (props.isPromotionCart ? '-3px' : 'none')};
      .express-badge {
        padding-right: 2px;
      }
    }
    .flash-badge {
      position: absolute;
      padding-top: 2px;
      margin-left: ${(props) => (props.isPromotionCart ? '-11px' : 'none')};
      .express-badge {
        padding-right: 2px;
      }
    }
    .union-logo-container {
      position: absolute;
      display: flex;
      align-items: center;
      bottom: 8px;
      right: 17px;
      transform: translate(50%, 50%);
      border: 1.06px solid ${(props) => props.theme.color.borderLight};
      border-radius:100%;
      padding: 6px;
      background-color: ${(props) => props?.theme?.green?.darkGreen};
    }

    .union-logo-container-disabled {
      position: absolute;
      display: flex;
      align-items: center;
      bottom: 8px;
      right: 17px;
      transform: translate(50%, 50%);
      border: 1.06px solid ${(props) => props.theme.color.borderLight};
      border-radius: 8.5px;
      padding: 6px;
      background-color: ${(props) => props.theme.color.white};
      padding-top: 4px;
      pointer-events: none;
    }
    .click-count {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      right: 6px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      font-size: 8px;
      border: 1px solid ${(props) => props.theme.color.borderLight};
      background-color: ${(props) => props.theme.color.green};
    }
    .click-text {
      color: ${(props) => props.theme.color.white};
      font-size: 6px;
    }
    ${(props) =>
      props.isPromotionCart &&
      `
        .click-count {
          display: none;
        }
      `}
  }
  .btn.btn-sm{
    height:40px;
  }

  .add-to-card {
    position:absolute;
    bottom:0;
    right:0;
    .cart-icon {
      width: 40px !important;
      height: 40px !important;
    }
    .disabled-cart {
      width: 80px !important;
      height: 32px !important;
      margin-bottom:0;
      margin-right:0;
    }
    .col-lg-12 {
      padding-left: 0;
    }
    .quantity-wrapper {
      position: relative;
      margin-bottom: 2px;
      margin-right: 4px;
      .txtLoading {
        .dropdown-wrapper {
          &.dropdown {
            .dropdown-toggle {
              font-size: 11px;
            }
          }
        }
      }
      .dropdown-wrapper {
        &.dropdown {
          .dropdown-toggle {
            text-align: center;
            font-weight: 700;
            font-size: 17px;
            color: ${(props) => props.theme.green.dark};
            border:1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
            border-radius: 100px;
            width: 84px;
            height: 32px;
            padding: 4px 30px 4px 30px;
            &:after {
              display: none;
            }
          }
          .dropdown-menu {
            &.show {
              a {
                display: none;
              }
            }
          }
        }
      }
      .decrease-product {
        width: 28px;
        position: absolute;
        top: 2px;
        left: 2px;
        cursor: pointer;
      }
      .increase_product {
        width: 28px;
        position: absolute;
        top: 2px;
        right: 2px;
        cursor: pointer;
      }
    }
  }
  .produt-detail-wrapper {
    height: auto;
  }
  .mini-cart-product-details {
    font-size: 12px;
    text-align: center;
  }

  .product-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 96%;
    height: ${(props) => (props.isPromotionCart ? '38px' : '')};
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => (props.isPromotionCart ? '12px' : '8px')};
    white-space: normal;
    text-align: left;
    padding-top: ${(props) => (props.isPromotionCart ? '8px' : '10px')};
    font-weight: 500;
    line-height:${(props) => (props.isPromotionCart ? '1.3' : '')};
  }
  
  .product-name-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    width: 100%;
    height: ${(props) => (props.isPromotionCart ? '38px' : '')};
    overflow: hidden;
    font-size: ${(props) => (props.isPromotionCart ? '12px' : '8px')};
    white-space: normal;
    text-align: left;
    padding-top: ${(props) => (props.isPromotionCart ? '8px' : '10px')};
    font-weight: 500;
    line-height: ${(props) => (props.isPromotionCart ? '1.3' : '11px')};
    word-break: break-all;
  }

  .mini-cart-cost {
    height: ${(props) => (props.isPromotionCart ? '50px' : '28px')};
    .price {
      text-align: left;
      font-weight: bold;
      padding-top: ${(props) => (!props.showFillerTitle ? '10px' : '4px')};
      font-size: ${(props) => (props.isPromotionCart ? '16px' : '10px')};
    }
    .special-price {
      text-align: left;
      color: ${(props) => props?.theme?.text?.medium};
      font-size: ${(props) => (props.isPromotionCart ? '11px' : '9px')};
      font-weight: 500;
      text-decoration-line: line-through;
    }
    .add-to-cart-container {
      padding-top: 7px;
    }
  }

  @media (max-width: 767px) {
    .cart-filler-mini-cart {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      padding-top: ${(props) => (props.title ? '22px' : '0px')};
      width: 85px;
      ${(props) =>
        props.isPromotionCart &&
        ` 
          border: 1px solid #E3E9EF ;
          border-radius: 8px ;
          padding: 5px ;
          height: ${!props.showFillerTitle ? '209px' : '258px'};
          width: 127px ;
          
        `}
    }
    .add-to-card {
      padding-top:0px;
    }
  }
`;